import { postData } from './request';
import type { ManufacturingIssue } from '@cutr/constants/order-files';

export function setManufacturingIssueVisibility(payload: {
  ids: string[];
  show: boolean;
}) {
  return postData<ManufacturingIssue[]>(
    '/v2/manufacturing-issues/visibility',
    payload
  );
}

export function setManufacturingIssueValidity(payload: {
  ids: string[];
  isValid: boolean;
}) {
  return postData<ManufacturingIssue[]>(
    '/v2/manufacturing-issues/validity',
    payload
  );
}
